import React, {PropsWithChildren, useContext} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {Customer} from "../models/customer.model";

export const CustomerContext = React.createContext({} as Customer);

export const CustomerProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <CustomerContext.Provider value={data.customer}>
            {children}
        </CustomerContext.Provider>
    )
}